import React, {memo, useState} from 'react';

import {api} from '@utils/api';
import {getFormattedShippingOptionName} from '@utils/functions';
import Loading from '@components/Loading';
import {useCart} from '@context/CartProvider';

function getCommonDeliveryTimeframe(options) {
	if (!options || options.length === 0) {
		return;
	}
	if (options && options.length > 0 && options[0].option === 'Instore') {
		return;
	}
	const flag = {};
	let unique = [];
	options.forEach(item => {
		if (item.product_id && !flag[item.product_id]) {
			flag[item.product_id] = true;
			unique.push(item);
		}
	});
	let timeframeFlag = {};
	let timeFrameUnique = [];
	let finalObjTimeframe = {};
	unique.forEach((item, index) => {
		if (finalObjTimeframe[item.delivery_timeframe]) {
			finalObjTimeframe[item.delivery_timeframe].push(index);
		} else {
			finalObjTimeframe[item.delivery_timeframe] = [];
			finalObjTimeframe[item.delivery_timeframe].push(index);
		}
		if (!timeframeFlag[item.delivery_timeframe]) {
			timeframeFlag[item.delivery_timeframe] = true;
			timeFrameUnique.push(item);
		}
	});
	if (
		timeFrameUnique.length === 1 &&
		timeFrameUnique[0].delivery_timeframe &&
		timeFrameUnique[0].delivery_timeframe.length > 0
	) {
		let incomingString = timeFrameUnique[0].delivery_timeframe;
		let deliverydays;
		//extracting numbers from string

		let numberPattern = /\d+/g;
		const numberArray = incomingString.match(numberPattern);
		if (numberArray) {
			if (numberArray?.length === 1) {
				deliverydays = numberArray[0] + ' ' + 'business days';
				return deliverydays;
			} else if (numberArray?.length === 2) {
				deliverydays =
					numberArray[0] +
					' ' +
					'to' +
					' ' +
					numberArray[1] +
					' ' +
					'business days';
				return deliverydays;
			}
		} else {
			deliverydays =
				timeFrameUnique[0]?.delivery_timeframe + ' ' + 'business days';
			return deliverydays;
		}
		// return timeFrameUnique[0].delivery_timeframe;
	}
	let timeFrameKeys = Object.keys(finalObjTimeframe);
	let html = '';
	let counter = 0;
	timeFrameKeys.forEach(item => {
		if (item !== '') {
			counter = 1;
			let text = 'Product ';
			finalObjTimeframe[item].forEach((number, index) => {
				if (index < finalObjTimeframe[item].length - 1) {
					text += `${number + 1} and `;
				} else {
					text += `${number + 1} `;
				}
			});
			text += `: ${item}`;
			html += text;
		}
	});
	if (counter === 1) {
		return html;
	} else {
		return;
	}
}

function Items(props) {
	const {
		styles,
		session,
		isGuest = false,
		selected,
		dispatch,
		item,
		cartData,
		user,
		country,
	} = props;
	const [loading, setLoading] = useState(false);
	const {state} = useCart();
	const [option, setOption] = useState(selected);

	const handleChange = async shipping => {
		setLoading(true);
		const amtKey =
			country === 'New Zealand' ? 'totalAmountExTax' : 'total_amount';
		const amount = state.items
			.filter(item => item.retailer_id === shipping.retailer_id)
			.map(i => i[amtKey])
			.reduce((a, b) => a + b, 0);
		if (
			shipping.freeShipping !== null &&
			shipping.value > 0 &&
			amount >= shipping.freeShipping
		) {
			shipping.value = 0;
			shipping.actualValue = 0;
		}

		const res = await api(
			{
				url: '/cart/update-shipping',
				method: 'POST',
				data: {
					shipping,
					isGuest,
				},
			},
			session,
		);

		const cData = cartData(res, user);
		setOption(shipping.option);
		dispatch({
			type: 'SET_DATA',
			data: {
				shipping: cData.shipping,
				promo: cData.promo,
				total: cData.total,
			},
		});
		setLoading(false);
	};

	const getShippingAmount = op => {
		const amtKey =
			country === 'New Zealand' ? 'totalAmountExTax' : 'total_amount';
		let amountTxt = op.value > 0 ? `$${op.value.toFixed(2)}` : 'Free';
		if (
			op.free_shipping !== 'undefined' &&
			(op.free_shipping > 0 || op.free_shipping === 0)
		) {
			const amountTotal = state.items
				.filter(item => item.retailer_id === op.retailer_id)
				.map(i => i[amtKey])
				.reduce((a, b) => a + b, 0);

			if (op.free_shipping !== null && amountTotal >= op.free_shipping) {
				amountTxt = 'Free';
			}
		}
		return amountTxt;
	};

	return (
		<div className={styles.shippingOp}>
			{item.options.length &&
				item.options.map((op, key) => (
					<div key={key} className={styles.deliveryOption}>
						<label className={styles.checkoutRadio}>
							<span className={styles.radioFree}>{getShippingAmount(op)}</span>
							<span className={styles.radioHd}>
								{getFormattedShippingOptionName(op.option)}
							</span>
							<span
								className={styles.dayHd}
								dangerouslySetInnerHTML={{
									__html: getCommonDeliveryTimeframe(op.arrOptions),
								}}
							/>
							{op.free_shipping > 0 && (
								<span className={styles.radioInfo}>
									Free shipping on orders above ${op.free_shipping.toFixed(2)}
								</span>
							)}
							<input
								type='radio'
								name={item.retailer_id}
								checked={option === op.option ? true : false}
								onChange={() =>
									handleChange({
										// eslint-disable-next-line babel/camelcase
										retailer_id: item.retailer_id,
										option: op.option,
										value: op.value,
										freeShipping: op.free_shipping,
										actualValue: op.actualValue,
									})
								}
							/>
							<span className={styles.checkmark}></span>
						</label>
					</div>
				))}
			{loading && (
				<div className={styles.outerOverlay}>
					<div className={styles.positionRel}>
						<div className={styles.overlay}></div>
						<div className={styles.loaderPosition}>
							<Loading.LineLoader />
						</div>
					</div>
				</div>
			)}
		</div>
	);
}

export default memo(Items);
